import React from "react";
import locale from "../../../../../../locale";
import { EMOJI_CATEGORIES_I18N_KEYS, MESSAGE_EMOJI_SRC } from "../../../../../../../platform/src/constants/components/emoji";

const EmojiListItem = ({category, emojiList, filteredEmoji, onSelectEmoji, activeReactions, onRemoveEmoji, disabled}) => {

    return (
        <li
            data-emoji-category={category}
            data-type="emoji-list-item"
        >
            <div className="emoji-picker-smileys-item">
                <span className="emoji-picker-smileys-item-name">
                    {locale(`emoji.${EMOJI_CATEGORIES_I18N_KEYS[category]}`)}
                </span>
                <span className="emoji-picker-smileys-list">
                    {emojiList?.map((emoji, index) => {
                        if (!filteredEmoji?.includes(index)) {
                            return null;
                        }

                        const emojiCode = emoji.codes.join('_');
                        const isActive = activeReactions?.includes(emojiCode);

                        return (
                            <div
                                className={`emoji-picker-smileys-item-image ${(isActive || disabled) ? '--active' : ''}`}
                                key={emoji?.codes}
                                onClick={() => {
                                    if (disabled) {
                                        return;
                                    }

                                    if (isActive) {
                                        onRemoveEmoji(emojiCode)
                                    } else {
                                        onSelectEmoji(emojiCode)
                                    }
                                }}
                            >
                                <img
                                    src={MESSAGE_EMOJI_SRC(emojiCode)}
                                    alt=""
                                />
                            </div>
                        )
                    })}
                </span>
            </div>
        </li>

    );
};

export default EmojiListItem;
